import { Link } from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger } from '@bliks-io/ui';

export interface TabNavItem {
  value: string;
  label: string;
  to: string;
}

interface TabNavProps {
  tabs: TabNavItem[];
  activeTab: string;
  slug: string;
  className?: string;
}

/**
 * Generic tab navigation component with sticky positioning.
 * Provides consistent tab styling and navigation across different pages.
 *
 * Usage:
 * ```tsx
 * <TabNav
 *   tabs={[
 *     { value: 'overview', label: 'Overview', to: '/$slug/overview' },
 *     { value: 'settings', label: 'Settings', to: '/$slug/settings' }
 *   ]}
 *   activeTab="overview"
 *   slug={slug}
 * />
 * ```
 */
export function TabNav({ tabs, activeTab, slug, className = '' }: TabNavProps) {
  return (
    <div className={`sticky top-0 z-10 border-b bg-sidebar ${className}`}>
      <Tabs value={activeTab}>
        <TabsList>
          {tabs.map((tab) => (
            <Link key={tab.value} to={tab.to} params={{ slug }}>
              <TabsTrigger value={tab.value}>{tab.label}</TabsTrigger>
            </Link>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
